export const googleCalendarUrlAlbert =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2gEsYYm116A4SJ4-SKkbfdlsLWUQHAj8S5jvcJzhLbl-lOjfWp3zT3hqNIbQxpRyaAtIZIwzD3";
